'use strict';

/* global $ */

class Scroll {
    constructor() {
        this.init();
    }
    init() {
        console.log('[ Scroll ] init');
        this.jsSmoothScroll();
    }
    jsSmoothScroll() {
      $('.js-smooth-scroll').click(function(e) {
        var href = $(this).attr('href'), idx = href.indexOf('#');
		var offset = $(this).data('offset') || 0;
        var id = idx != -1 ? href.substring(idx+1) : '';
        if (id == '') { return true; }
        e.preventDefault();
		if ($('#' + id).length) {
	        var top = $('#' + id).offset().top + offset;
	        $('body,html').animate({scrollTop: top}, 1500, "swing");
		}
      });
    };

}

export {
  Scroll
};
